import { render, staticRenderFns } from "./promoDetails.vue?vue&type=template&id=a7ab9050&"
import script from "./promoDetails.vue?vue&type=script&lang=js&"
export * from "./promoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports